var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.818,
    viewBox: "0 0 20 17.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M13.318.354a2.793,2.793,0,0,1,1.366,1.265l.122.212.452.867.015.024h0l.014.021.038.053a1.188,1.188,0,0,0,.778.36A3.9,3.9,0,0,1,20,6.852l.005.2v5.795a4.971,4.971,0,0,1-4.754,4.965l-.216,0H4.97A4.97,4.97,0,0,1,0,13.063l0-.216V7.052a3.9,3.9,0,0,1,3.9-3.9,1.191,1.191,0,0,0,.778-.36l.007-.008h0l.009-.012L4.743,2.7l.451-.866A2.965,2.965,0,0,1,6.682.354,15.7,15.7,0,0,1,13.318.354ZM7.237,1.748a1.433,1.433,0,0,0-.636.646l-.093.161L6.123,3.3l-.095.171a2.078,2.078,0,0,1-.248.341,2.7,2.7,0,0,1-1.709.838L3.9,4.656l-.164.006A2.4,2.4,0,0,0,1.506,6.888L1.5,7.052v5.795a3.47,3.47,0,0,0,3.28,3.465l.19.005H15.03a3.471,3.471,0,0,0,3.465-3.28l.005-.19V7.052a2.4,2.4,0,0,0-2.233-2.39L16.1,4.656l-.174-.007A2.694,2.694,0,0,1,14.22,3.81a2.074,2.074,0,0,1-.246-.338l-.019-.032h0l-.023-.04-.116-.218-.324-.628a1.867,1.867,0,0,0-.635-.762l-.094-.045-.119-.04A16.078,16.078,0,0,0,7.237,1.748ZM10,6.2a3.929,3.929,0,1,1-3.929,3.929A3.929,3.929,0,0,1,10,6.2Zm0,1.5a2.429,2.429,0,1,0,2.429,2.429A2.429,2.429,0,0,0,10,7.7Zm5.5-2.2a1,1,0,0,1,.117,1.993L15.5,7.5a1,1,0,0,1-.126-1.993Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.474d3e2669cdf0b694af64ca1e36fa9a.svg";
export { ForwardRef as ReactComponent };